import TransactionalEmailsService from '../../services/transactionalEmails'

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
  getTransactionalEmailSummary(context, params) {
    return new Promise((resolve, reject) => {
      TransactionalEmailsService.getSummary(params).then(response => {
        resolve(response.data)
      }).catch(error => { reject(error) })
    })
  },

  getTransactionalEmailMessages(context, params) {
    return new Promise((resolve, reject) => {
      TransactionalEmailsService.getMessages(params).then(response => {
        resolve(response.data)
      }).catch(error => { reject(error) })
    })
  },

  getTransactionalEmailMessage(context, params) {
    return new Promise((resolve, reject) => {
      TransactionalEmailsService.getMessage(params).then(response => {
        resolve(response.data)
      }).catch(error => { reject(error) })
    })
  }
}
